import { useIntl } from "react-intl";

import Textarea from "components/v2/Textarea/Textarea";
import FormSectionLabel from "pages/shipper/RequestFormV2/components/FormSectionLabel/FormSectionLabel";
import { useOrganisation } from "@RequestFormV2/sections/Organisation/context/useOrganisation";

export default function ShipmentDetails() {
  const intl = useIntl();
  const { longField01 } = useOrganisation();

  return (
    <>
      {longField01 && (
        <div className="rfv2-form-section">
          <FormSectionLabel label={longField01.label} />

          <div className="rfv2-form-section__content">
            <label className="form-label">
              {intl.formatMessage({
                id: "request-form.organisation.long-field-01-textarea-label",
                defaultMessage: "Description",
              })}
            </label>
            <Textarea
              name="organizational.custom_long_field_01"
              required={longField01.mandatory}
              shouldUnregister
              defaultValue={longField01.initial_data}
            />
          </div>
        </div>
      )}
    </>
  );
}
